import { RouteObject } from 'react-router-dom';

import { Cost } from '@/pages/Fleet';

export const CostRoutes: RouteObject[] = [
  {
    path: 'costs',
    element: <Cost />,
  },
];
